import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FREE_PLAN_INVOICES_LIMIT_PER_MONTH } from 'shared/constants/invoices/limits';

import Button from '../Button';
import Modal from '../Modal';

import type { Props } from './types';

export function InvoiceCapReachedModal({ onClose }: Props) {
    const { t } = useTranslation();

    return (
        <Modal
            center
            isOpen
            styles="flex items-center justify-center p-[22px]"
            testID="InvoiceCapReachedModal"
        >
            <Box className="flex flex-col w-[440px]">
                <Typography className="mt-[3px] font-bold text-cranberry">
                    {t('Invoice:cap_reached_modal:title')}
                </Typography>
                <Typography className="mb-[44px] mt-[17px] text-base text-ebonyClay leading-relaxed font-light">
                    {t('Invoice:cap_reached_modal:message', {
                        limit: FREE_PLAN_INVOICES_LIMIT_PER_MONTH,
                    })}
                </Typography>
                <Box className="flex self-end">
                    <Button
                        caption={t('Invoice:cap_reached_modal:ok')}
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                    />
                </Box>
            </Box>
        </Modal>
    );
}
